module.exports = __webpack_public_path__ + "img/email-opened.640e2c66.svg";